import { request, requestWithPlanWarning } from '@/api/http';
import type { DeleteResult, Subscription } from '@/api/types';

export const subscriptionsService = {
  list: () => request<Subscription[]>('/subscriptions'),
  create: async (body: object) => {
    const { data, planWarning } = await requestWithPlanWarning<Subscription>('/subscriptions', {
      method: 'POST',
      body: JSON.stringify(body),
    });
    return { data, planWarning };
  },
  update: (id: string, body: object) =>
    request<Subscription>(`/subscriptions/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (
    id: string,
    opts?: {
      also_delete_search?: boolean;
      also_delete_user?: boolean;
      delete_scope?: string;
    }
  ) => {
    const params = new URLSearchParams();
    if (opts?.also_delete_search) params.set('also_delete_search', 'true');
    if (opts?.also_delete_user) params.set('also_delete_user', 'true');
    if (opts?.delete_scope) params.set('delete_scope', opts.delete_scope);
    const q = params.toString() ? `?${params}` : '';
    return request<DeleteResult>(`/subscriptions/${id}${q}`, { method: 'DELETE' });
  },
};
